import axios from "axios";
import { toast } from "sonner";
import { logger } from "@/lib/logger";

/**
 * Trigger a browser download of an Excel file from a backend endpoint.
 * Shared across statement pages (P&L, Balance Sheet, etc.).
 *
 * @param {string} url - full URL to the export endpoint
 * @param {object} params - query params to attach
 * @param {string} filename - suggested download file name
 */
export async function downloadExcel(url, params, filename) {
  try {
    const res = await axios.get(url, { params, responseType: "blob" });
    const blobUrl = URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
    toast.success("Excel downloaded");
    return true;
  } catch (err) {
    logger.error(`Download failed (${filename}):`, err);
    toast.error("Download failed: " + (err.message || "unknown error"));
    return false;
  }
}
